import { Header, Paragraph } from "@datagame/ui";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";

import { User } from "../../../../gql/graphql";
import { isAdmin } from "../../../../utils/user/isAdmin";
import { UserList } from "../UserList";

import styles from "./UsersSection.module.scss";

const cx = classNames.bind(styles);

export interface UsersSectionProps {
  users?: User[];
  currentUser?: User;
}

export const UsersSection = ({ users, currentUser }: UsersSectionProps) => {
  const { t } = useTranslation();

  const isAdminUser = isAdmin(currentUser?.role);

  return (
    <div className={cx("section", { fullWidth: !isAdminUser })}>
      <div className={styles.headerWrapper}>
        <div className={styles.content}>
          <Header variant="h5">{t("company:usersSection.title")}</Header>
          <Paragraph size="small">{t("company:usersSection.description")}</Paragraph>
        </div>
      </div>

      {users && <UserList users={users} currentUser={currentUser} />}
    </div>
  );
};
